import React from "react";
import { Link } from "react-router-dom";
import { useLanguagesContext } from "hooks/useContextAll";
import { contentTranslation } from "data/404/translationPageNotFound";
import PageDirection from "components/PageDirection";

const PageNotFoundView = () => {
    const language = useLanguagesContext();

    return (
        <PageDirection>
            <div className="page-not-found-box">
                <div className="icon-box">
                    <ion-icon name="planet-outline"></ion-icon>
                </div>
                <div className="text-box">
                    <h3>{contentTranslation.title[language.language].text}</h3>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: contentTranslation.subTitle[language.language]
                                .text,
                        }}
                    ></p>
                </div>
                <Link className="btn btn-lg btn-primary" to="/">
                    {contentTranslation.backToHomeBtn[language.language].text}
                </Link>
            </div>
        </PageDirection>
    );
};

export default PageNotFoundView;
